module.exports = __webpack_public_path__ + "static/img/recognitionB.a352512f.png";